import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import CheckboxColumnList from "../CheckboxColumnList/CheckboxColumnList";

function BrandsSubmenu(props) {

    const [selectedBrands, setSelectedBrands] = useState([]);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(location.search);
        const brandsFromURL = urlSearchParams.get("brands");
        if (brandsFromURL) {
            setSelectedBrands(brandsFromURL.split(","));
        } else {
            setSelectedBrands([]);
        }
    }, [location.search]);


    const brandSelectedHandler = selectedBrands => setSelectedBrands(selectedBrands.map(brand => brand.name));

    const searchButtonClickHandler = () => {
        let searchParameters = {
            brands: selectedBrands
        }

        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(searchParameters)
        });

        props.onClose();
    }



    return (
        <form id="szukaj-marki-form" action="">
            <CheckboxColumnList
                selectedItems={selectedBrands.map(name => ({name}))}
                resetItems={selectedBrands.length === 0}
                columnCount={4}
                items={props.brands}
                onChange={brandSelectedHandler}
            />

            <div className="form-line">
                <button type="button" onClick={searchButtonClickHandler}>Szukaj</button>
            </div>
        </form>

    );
}

export default BrandsSubmenu;